import { html, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { customElement } from 'lit/decorators.js';

import { PopBaseComponent } from '../../base/pop-base-component.js';
import type { ExampleUsageContentObject } from './example-usage.model.js';
import style from './example-usage.scss?inline';
import { Constants } from './example-usage.constants.js';
import { beaconTestContent } from '../../base/base.model.mock.js';

/**
 * @tag pop-example-usage-component
 * @attribute {ExampleUsageContentObject} [data-component-object] Example usage content
 * @slot content - contains example usage content
 */
@customElement(Constants.TAG_NAME)
export class ExampleUsage extends PopBaseComponent {
  static get styles() {
    return [...super.styles, unsafeCSS(style)];
  }

  /**
   * @internal
   */
  tagName = Constants.TAG_NAME;

  /**
   * The component object that contains the pre-fetched data to be rendered.
   */
  componentObject?: ExampleUsageContentObject;

  constructor() {
    super();
  }

  render() {
    return this.renderComponent(
      html`
        <h1>${unsafeHTML(this.componentObject?.title)}</h1>
        ${unsafeHTML(beaconTestContent('shadowdom beacon content'))}
        <div
          class="b-container b-padding-block-start--macro--mini b-padding-block-end--macro--mini"
        >
          <h3>Slot content below</h3>
          <slot name="content"></slot>
        </div>
      `,
      this.componentObject?.popClasses || '',
    );
  }
}
